import React, { useState } from "react";
import styles from "./layout.module.scss";
import LumiRXLogo from "../../assets/images/logo/LumiLogo.svg";
import MenuItems from "./SidebarItems/MenuItems";
import { Link } from "react-router-dom";

import ProfileDropdown from "./SidebarItems/ProfileDropdown/ProfileDropdown";
import AddAdmin from "./SidebarItems/AddAdmin";
import Invited from "./SidebarItems/Invited";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";

const Sidebar = () => {
  const [adminModalOpen, setAdminModalOpen] = useState(false);
  const [invitedOpen, setInvitedOpen] = useState(false);
    const [loading, setLoading] = useState(false);

  const toggle = () => {
    setAdminModalOpen(!adminModalOpen);
  };

  const openAdminModal = () => {
    setAdminModalOpen(true);
  };

  const invitedToggle = () => {
    setInvitedOpen(!invitedOpen);
  };
  return (
    <div className={styles["layout_container"]}>
      {loading && <CuteMascotSpinner />}
      {adminModalOpen && (
        <AddAdmin
          openModal={adminModalOpen}
          toggle={toggle}
          setInvitedOpen={setInvitedOpen}
          setLoading={setLoading}
        />
      )}
      {invitedOpen && (
        <Invited openModal={invitedOpen} toggle={invitedToggle} />
      )}
      <div className={styles["logo_container"]}>
        <Link to={"/dashboard"}>
          <img src={LumiRXLogo} alt="" />
        </Link>
      </div>
      <div className={styles["profile_dropdown_container"]}>
        <ProfileDropdown openAdminModal={openAdminModal} />
      </div>
      <div className={styles["sidebar_menuitems_container"]}>
        <MenuItems />
      </div>
    </div>
  );
};

export default Sidebar;
